import React from 'react';
import { Editor, EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';

export class RichTextEditor extends React.Component {
    constructor(props) {
        super(props);
            let contentState;
            try {

                 contentState = props.input.value ? convertFromRaw(JSON.parse(props.input.value)) : null;
                 
            } catch (error) {
                console.error("Ошибка парсинга контента:", error);
                contentState = null;
            }

            this.state = {
                editorState: contentState 
                    ? EditorState.createWithContent(contentState)
                    : EditorState.createEmpty(),
            };
        this.onChange = (editorState) => {
            this.setState({ editorState });
            const rawContent = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
            props.input.onChange(rawContent); 
        };

        
    }

    render() {
        return (
            <div className='form-group'>
                <label className='control-label col-sm-3'>{this.props.label}</label>
                <div className='controls col-sm-9'>
                    <div 
                        className='editor-container'
                        style={{
                            width: '400px', 
                            height: '500px', 
                            resize: 'vertical', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px', 
                            padding: '5px',
                            minHeight: '100px' 
                        }}
                    >
                        <Editor 
                            editorState={this.state.editorState} 
                            onChange={this.onChange} 
                            placeholder="Введите описание..." 
                            input = {this.props.input}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/RichTextEditor.jsx